import React from 'react';
import { dehydrate, QueryClient } from '@tanstack/react-query';
import { ArrowLeftIcon } from 'icons';
import { GetStaticProps } from 'next';
import Link from 'next/link';
import { useTranslations } from 'next-intl';

import { useAppSelector } from 'store';

import {
  courseConst,
  CoursesList,
  FilterCourse,
  getTeachers,
  ITeacher,
  TeachersList
} from 'modules/courses';
import { globalConst, infinityNextPageParam, IWithPagination } from 'modules/global';

import { NextHead } from 'components';

const Index = () => {
  const t = useTranslations();
  const type = useAppSelector(({ courses }) => courses.type);

  return (
    <>
      <NextHead title={t('meta.courses_filter.title')} description={t('meta.courses_filter.description')} />

      <div className="mx-auto min-h-screen max-w-screen p-4 md:my-7">
        <Link
          href={globalConst.pageNames.COURSES}
          className="inline-flex cursor-pointer items-center justify-start gap-2 font-semibold"
        >
          <ArrowLeftIcon /> {t('common.ortga_qaytish')}
        </Link>
        <FilterCourse />

        <div>{type === 'teachers' ? <TeachersList /> : <CoursesList />}</div>
      </div>
    </>
  );
};

export default Index;

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  const queryClient = new QueryClient();

  await Promise.allSettled([
    // queryClient.prefetchInfiniteQuery({
    //   queryKey: [courseConst.queryKeys.COURSES, null, null, null, null],
    //   queryFn: getCourses({ search: '', type: undefined }),
    //   getNextPageParam: infinityNextPageParam<IWithPagination<ICourse[]>>(24)
    // }),
    queryClient.prefetchInfiniteQuery({
      queryKey: [courseConst.queryKeys.TEACHERS, null],
      queryFn: getTeachers({ search: '' }),
      getNextPageParam: infinityNextPageParam<IWithPagination<ITeacher[]>>(32)
    })
  ]);

  return {
    props: {
      dehydratedState: JSON.parse(JSON.stringify(dehydrate(queryClient))),
      messages: (await import(`../../messages/${locale}.json`)).default
    },
    revalidate: 604800
  };
};
